module.exports = __webpack_public_path__ + "bolt.d00e3ab3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/bolt.png
// module id = 330
// module chunks = 0